module.exports = __webpack_public_path__ + "static/rocket-surgery-made-easy-40153ba551e9e4896f00cddb9266690b.jpg";